import React from "react";
import UpdateProfile from "./components/UpdateProfile/UpdateProfile";

const Profile = () => {
  return <UpdateProfile />;
};

export default Profile;
